import React from 'react';
import { mapKeysDeep } from 'app/lib/lodashUtils';
import { camelizeKey } from 'app/lib/utils';
import TestMemberChooser from '../containers/TestMemberChooser';
import TestOptions from '../containers/TestOptions';
import TestResults from '../containers/TestResults';
import TestErrors from '../containers/TestErrors';
import '../rte-test.scss';

const RteTestComponent = ({ payers }) => {
  const payersData = payers.map(p => mapKeysDeep(p, camelizeKey));

  return (
    <div>
      <TestErrors />
      <table id="rte-test-layout">
        <tbody>
          <tr>
            <td>
              <TestMemberChooser payers={payersData} />
            </td>
            <td>
              <TestOptions payers={payersData} />
            </td>
          </tr>
        </tbody>
      </table>

      <TestResults />
    </div>
  );
};

export default RteTestComponent;
